import request from "./core/index";

// Works 데이터 인터페이스
export interface WorkSimple {
  id: number;
  title: string;
  slug: string;
  workScope: string;
  industry: string;
  thumbnailUrl: string;
  isVisibleOnHome: boolean;
  seq: number;
}

// 작품 타입 정의
export interface WorkItem {
  id: number;
  slug?: string; // URL slug 추가
  title: string;
  workScope: string;
  industry: string;
  client: string;
  brand: string;
  tags: string[];
  category: string;
  description: string;
  thumbnailUrl: string;
  thumbnailType: string;
  private?: boolean; // 잠금 기능을 위한 private 필드 추가
}

// Work 타입 정의
export interface WorkDetailItem {
  id: number;
  slug?: string; // URL slug 추가
  title: string;
  description: string;
  workScope: string;
  industry: string;
  client: string;
  brand: string;
  tags: string[];
  category: string;
  thumbnailUrl: string;
  thumbnailType: string;
  detailImageUrls: string[];
  metaDescription: string;
  metaKeywords: string;
  videos?: string[];
  private?: boolean;
}

/**
 * 작업 데이터를 API에서 가져오는 함수
 * @returns Promise with Works data
 */
export const fetchWorks = async (): Promise<WorkItem[]> => {
  const url = `/api/works`;
  return request.get<WorkItem[]>(url);
};

/**
 * 특정 ID의 작업 상세 데이터를 API에서 가져오는 함수
 * @param id 작업 ID
 * @returns Promise with Work detail data
 */
export const fetchWorkById = async (id: string): Promise<WorkDetailItem> => {
  const url = `/api/works/${id}`;
  return request.get<WorkDetailItem>(url);
};

/**
 * 메인 홈에 표시되는 작업 데이터를 API에서 가져오는 함수
 * @returns Promise with Home Works data (WorkSimple array)
 */
export const fetchHomeWorks = async (): Promise<WorkSimple[]> => {
  const url = `/api/works/home`;
  return request.get<WorkSimple[]>(url);
}; 